module.exports = __webpack_public_path__ + "static/media/28.935bb970.mp3";